import { Box, Card } from "@mui/material";
import { useEffect, useState } from "react";
import { FileType, createResourceEndpointUrl } from "../../../helper/utils";
import { FlattenedGadget } from "../../../models/GadgetModel";
import { GadgetIcon } from "../../Home/components/gadgets/GadgetIcon";
import { CustomModal } from "../../../components/Modal/CustomModal";
import styles from "../css/GadgetScreenshotInfo.module.css";

interface GadgetScreenshotInfoProps {
    gadget: FlattenedGadget
}

export const GadgetScreenshotInfo = ({gadget}: GadgetScreenshotInfoProps) => {
    const style = { width: 200, margin: '10px'};
    const [snapshots, setSnapshots] = useState<Array<string>>([]);
    const [openModal, setOpenModal] = useState(false);
    const handleCloseModal = () => setOpenModal(false);
    const [screenshotUrlOnModal, setScreenshotUrlOnModal] = useState<string>("");
    const handleOpenModal = (index: number) => {
        setOpenModal(true);
        setScreenshotUrlOnModal(snapshots[index]);
    };
    const iconStyle = { margin: '10px'};

    useEffect(() => {
        if (gadget.snapshots) {
            setSnapshots(gadget.snapshots.map((filename) => createResourceEndpointUrl(gadget?.id, gadget?.version, gadget?.platform, FileType.SNAPSHOT, filename)));
        }
    }, [gadget]);
    
    return (
        <Box className={styles.container}>
            <CustomModal
                open={openModal} 
                handleClose={handleCloseModal} 
                children={<GadgetIcon image={screenshotUrlOnModal} altText="Gadget icon" styles={iconStyle} dataTestId="gadget-screenshot"/>}
            />
            {snapshots.map((snapshotUrl, i) => (
                <Card onClick={() => handleOpenModal(i)} className={styles.card} key={i}>
                    <GadgetIcon image={snapshotUrl} altText="Gadget icon" styles={style} dataTestId="gadget-screenshot"/>
                </Card>
            ))}
        </Box>
    )
}